import { Container } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Alert from '../../../../components/Alert';
import { fetchInstance } from '../../../../redux/safescarf/instance/actions';
import Page404 from '../../../Error/Page404';

import Instance from './Instance/Instance';
import InstanceStatus from './Instance/InstanceStatus';

import type { RootState } from '@/redux/store';

interface InstanceData {
  status?: number;
  progress?: number | string;
  api?: unknown;
  [key: string]: unknown;
}

const SafescarfProduct: React.FC = () => {
  const dispatch = useDispatch();
  const instance = useSelector(
    (state: RootState) => state.safescarf.instance?.data
  ) as InstanceData;

  useEffect(() => {
    dispatch(fetchInstance());
  }, [dispatch]);

  if (instance.status === 403) {
    return (
      <Container sx={{ marginTop: 4 }}>
        <Alert
          mode='warning'
          title='SafeSCARF Integration Disabled'
          text='SafeSCARF integration is currently disabled. Please contact support for more information.'
        />
      </Container>
    );
  }

  if (instance.status) {
    if (instance.status === 404) {
      return <Page404 />;
    }

    if (instance.status === 200) {
      const progress = parseFloat(String(instance.progress ?? '0'));

      if (progress !== 1.0) {
        return <InstanceStatus progress={instance.progress as number} />;
      }

      if (instance.api) {
        return <Instance />;
      }
    }
  }

  return null;
};

export default SafescarfProduct;
